import {
  ToastController
} from 'ionic-angular/components/toast/toast-controller';
import {
  Provider
} from './../../model/index';
/*import {
  dns
} from '../../../../providers/global.config';*/
import {
  NavParams
} from 'ionic-angular';
import {
  Component
} from '@angular/core';
import {
  OilChange,
  OilChangeInfo,
  TypeOil,
  DateInterval
} from '../../model/index';
import {
  OilChangeService
} from '../../../../providers/oil-change.service';
import {
  Subscription
} from 'rxjs/Subscription';
import {
  Observable
} from 'rxjs/Rx';
import {
  FileUploader
} from 'ng2-file-upload';
import {
  AlertController
} from 'ionic-angular/components/alert/alert-controller';
import {
  ViewController
} from 'ionic-angular/navigation/view-controller';

@Component({
  templateUrl: 'vidange-form.html',
})
export class VidangeForm {
  oil: any;
  showupdate: boolean = true;
  showtypemoteur: boolean = false;
  showtypehuile: boolean = false;
  showtypefair: boolean = false;
  showtypefcarburant: boolean = false;
  showtypefseparator: boolean = false;
  showfournisseur: boolean = false;
  operationTime: any;
  listProviders: Provider[] = [];
  idProvider: any;
  listType: TypeOil[] = [{
      name: "5000",
      value: 5000
    },
    {
      name: "8000",
      value: 8000
    },
    {
      name: "10000",
      value: 10000
    },
    {
      name: "15000",
      value: 15000
    },
    {
      name: "20000",
      value: 20000
    },
    {
      name: "30000",
      value: 30000
    },
    {
      name: "40000",
      value: 40000
    },
    {
      name: "50000",
      value: 50000
    },
    {
      name: "Autres",
      value: -1
    }
  ];
  constructor(public viewCtrl: ViewController, private toastCtrl: ToastController, public navParams: NavParams, private oilChangeService: OilChangeService, public alertCtrl: AlertController) {
    this.oil = navParams.get('oil');
    if (this.oil.operationTime) {
      this.operationTime = (new Date(this.oil.operationTime)).toISOString();
    } else this.operationTime = (new Date()).toISOString();
    this.idProvider = this.oil.idProvider;
  }


  ngOnInit() {
    this.oilChangeService.getProviders("MAINTENANCE").subscribe(response => {
      this.listProviders = response;
      console.log(response)
    });
  }
  precisionRound(number: number, precision: number) {
    let factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
  }
  closeModal() {
    this.viewCtrl.dismiss(null);
  }

  typehmoteur(type: any) {
    if (type == -1) {
      this.showtypemoteur = true;
      this.oil.typeEngineOil = 0;
    }
  }
  typehhuile(type: any) {
    if (type == -1) {
      this.showtypehuile = true;
      this.oil.typeOilF = 0;
    }
  }
  typefair(type: any) {
    if (type == -1) {
      this.showtypefair = true;
      this.oil.typeAirF = 0;
    }
  }
  typefcaruburant(type: any) {
    if (type == -1) {
      this.showtypefcarburant = true;
      this.oil.typeFuelF = 0;
    }
  }
  typefseparator(type: any) {
    if (type == -1) {
      this.showtypefseparator = true;
      this.oil.typeSeparatorF = 0;
    }
  }
  typefournisseur(type: any) {
    if (type == 0) {
      this.showfournisseur = true;
      this.oil.providerName = "";
      this.idProvider = -1;
    }
    this.idProvider = type;
  }
  update() {
    this.oil.operationTime = new Date(this.operationTime);
    if (this.oil.engineOil != false || this.oil.oilF != false ||
      this.oil.airF != false || this.oil.fuelF != false ||
      this.oil.separatorF != false) {
      let valid1 = this.validationTypeEngineOil();
      let valid2 = this.validationTypeOilF();
      let valid3 = this.validationTypeAirF();
      let valid4 = this.validationTypeFuelF();
      let valid5 = this.validationTypeSeparatorF();
      if (valid1 && valid2 && valid3 && valid4 && valid5) {
        if (this.oil.cost >= 10) {
          if (this.oil.quantity < 0) {
            this.oil.quantity = 0;

          }
          let data = {
            oil: this.oil,
            idProvider: this.idProvider,
            providerName: this.oil.providerName
          }
          this.viewCtrl.dismiss(data);
        }
      }
    }
  }
  verify(value: number): boolean {
    let found: boolean = false;
    for (let j = 0; j < this.listType.length; j++) {
      if (this.listType[j].value == value) {
        found = true;
        break;
      }
    }
    if (!found && value != 0) {
      return true;
    }
    return false;
  }

  validationTypeEngineOil(): boolean {
    if (this.oil.engineOil && this.oil.typeEngineOil <= 0 || this.oil.quantity <= 0 && this.oil.engineOil) {
      if (this.oil.quantity <= 0) {
        let toast = this.toastCtrl.create({
          message: 'Veuillez entrer une valeur supérieure a 0 pour la Quantité',
          duration: 3000,
          position: 'top'
        });
        toast.present();
        //

      }
      if (this.oil.typeEngineOil <= 0) {
        let toast = this.toastCtrl.create({
          message: 'Veuillez entrer une valeur pour le type H Moteur',
          duration: 3000,
          position: 'top'
        });
        toast.present();
        // this.customOption.customToasterWarning(this.toastyService, 3000, "Veuillez entrer une valeur pour le type H Moteur");
      }
      return false;
    }
    if (!this.oil.engineOil) {
      this.oil.typeEngineOil = 0;
      //   console.log("here" + this.oilChange.typeEngineOil);
    }
    return true;
  }

  validationTypeOilF(): boolean {
    if (this.oil.oilF && this.oil.typeOilF <= 0) {
      let toast = this.toastCtrl.create({
        message: 'Veuillez entrer une valeur pour le type F Huile',
        duration: 3000,
        position: 'top'
      });
      toast.present();
      // this.customOption.customToasterWarning(this.toastyService, 3000, "Veuillez entrer une valeur pour le type F Huile");
      return false;
    }
    if (!this.oil.oilF) {
      this.oil.typeOilF = 0;
    }
    return true;
  }

  validationTypeAirF(): boolean {
    if (this.oil.airF && this.oil.typeAirF <= 0) {
      let toast = this.toastCtrl.create({
        message: 'Veuillez entrer une valeur pour le type F Air',
        duration: 3000,
        position: 'top'
      });
      toast.present();
      //   this.customOption.customToasterWarning(this.toastyService, 3000, "Veuillez entrer une valeur pour le type F Air");
      return false;
    }
    if (!this.oil.airF) {
      this.oil.typeAirF = 0;
    }
    return true;
  }

  validationTypeFuelF(): boolean {
    if (this.oil.fuelF && this.oil.typeFuelF <= 0) {
      let toast = this.toastCtrl.create({
        message: 'Veuillez entrer une valeur pour le type F Carburant',
        duration: 3000,
        position: 'top'
      });
      toast.present();
      //  this.customOption.customToasterWarning(this.toastyService, 3000, "Veuillez entrer une valeur pour le type F Carburant");
      return false;
    }
    if (!this.oil.fuelF) {
      this.oil.typeFuelF = 0;
    }
    return true;
  }

  validationTypeSeparatorF(): boolean {
    if (this.oil.separatorF && this.oil.typeSeparatorF <= 0) {
      let toast = this.toastCtrl.create({
        message: 'Veuillez entrer une valeur pour le type F Séparateur',
        duration: 3000,
        position: 'top'
      });
      toast.present();
      // this.customOption.customToasterWarning(this.toastyService, 3000, "Veuillez entrer une valeur pour le type F Séparateur ");
      return false;
    }
    if (!this.oil.separatorF) {
      this.oil.typeSeparatorF = 0;
    }
    return true;
  }

  add() {
    if (this.oil.engineOil != false || this.oil.oilF != false ||
      this.oil.airF != false || this.oil.fuelF != false ||
      this.oil.separatorF != false) {
      let valid1 = this.validationTypeEngineOil();
      let valid2 = this.validationTypeOilF();
      let valid3 = this.validationTypeAirF();
      let valid4 = this.validationTypeFuelF();
      let valid5 = this.validationTypeSeparatorF();
      if (valid1 && valid2 && valid3 && valid4 && valid5) {
        if (this.oil.cost >= 10) {
          if (this.oil.quantity < 0) {
            this.oil.quantity = 0;
          }
          let data = {
            oil: this.oil,
            idProvider: this.idProvider,
            providerName: this.oil.providerName
          }
          this.viewCtrl.dismiss(data);
        
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/gestion-park/vidange/vidange-form/vidange-form.ts